import React, { useRef } from "react";

import { Col } from "react-bootstrap";

import classNames from "classnames";

import { LeftArrowIcon, RightArrowIcon } from "@assets/icons";
import { IconButton } from "@components/IconButton";

import TrackerCard from "./TrackerCard";

import styles from "./ScrollTracker.module.scss";

const ScrollTracker = ({ steps, heading }: { steps: { heading: string; subtext: string }[]; heading: string }) => {
  const bannerRef = useRef<null | HTMLDivElement>(null);

  const scroll = (scrollOffset: number) => {
    if (bannerRef.current) {
      bannerRef.current.scrollLeft += scrollOffset;
    }
  };

  return (
    <div className={classNames(styles["banner-container"], "px-3 px-md-0")}>
      <div className={styles["header-row-wrapper"]}>
        <Col className="mb-0 px-0 h2" sm={5}>
          {heading}
        </Col>
        <Col sm={2} className="gap-5 d-none d-md-flex">
          <IconButton variant="tertiary" src={LeftArrowIcon} onClick={() => scroll(-200)}></IconButton>
          <IconButton variant="tertiary" src={RightArrowIcon} onClick={() => scroll(200)}></IconButton>
        </Col>
      </div>
      <div className={styles["banner-inner-container"]} ref={bannerRef}>
        <div className={styles["cards-wrapper"]}>
          {steps.map(({ heading, subtext }, index) => (
            <TrackerCard
              title={heading}
              text={subtext}
              key={heading}
              number={(index + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScrollTracker;
